import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2, Store, Upload, FileText, Check, ArrowRight, Building2, LogOut } from 'lucide-react';
import { toast } from 'sonner';
import { mccs } from "../lib/mockData";
// import { useAuth } from '../contexts/AuthContext';
import { useTranslation } from 'react-i18next';
import { Logo } from '../components/Logo';
import { LanguageToggle } from '../components/LanguageToggle';
import { Label } from '../components/ui/label';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { GetCookie, send, TOKEN_NAME } from '../components';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../components/ui/select";
import { useAuth } from '../contexts/AuthContext';
import { useLoading } from '../hooks/useLoading';
import axios from 'axios';

const MerchantSetup = () => {
  const [businessName, setBusinessName] = useState('');
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);
  const [isComplete, setIsComplete] = useState(false);
  // const [copied, setCopied] = useState(false);
  const [mcc, setMcc] = useState("");
  const { user, setUser, setAuth } = useAuth()
  const { showLoading } = useLoading()

  // const { user } = useAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const fileInputRef = useRef(null);
  // const payLink = businessName ? `${window.location.origin}/link/${generatePayLink(businessName)}` : '';

  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files?.[0];
    if (!selectedFile) return;

    // зөвхөн зураг шалгах (optional)
    if (!selectedFile.type.startsWith("image/")) {
      alert("Зөвхөн зураг файл оруулна уу");
      return;
    }

    setFile(selectedFile);

    // хуучин preview цэвэрлэх
    if (preview) URL.revokeObjectURL(preview);

    setPreview(URL.createObjectURL(selectedFile));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("businessName", businessName);
    formData.append("description", description);
    formData.append("mcc", mcc);
    if (file) formData.append("image", file);

    setLoading(true)
    axios.post("/api/v1/front/process", formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: 'Bearer ' + GetCookie(TOKEN_NAME),
        'pc': 'io0004',
      },
      transformRequest: formData => formData,
    }).then((res) => {
      if (res.data.response_code === "RC000000") {
        // setId(res.data.response)
        user.businessName = businessName;
        user.status = 2;
        setUser(user);
        toast.success(t("merchantAccountCreated"));
        setIsComplete(true);
      } else {
        toast.error(res.data.response);
      }
    }).catch((err) => {
      toast.error(err);
    }).finally(() => {
      setLoading(false);
    })
  };

  // const handleCopyLink = () => {
  //   // navigator.clipboard.writeText(payLink);
  //   setCopied(true);
  //   toast.success(t('copied'));
  //   setTimeout(() => setCopied(false), 2000);
  // };

  const handleGoToDashboard = () => {
    navigate('/merchant/dashboard');
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const logout = async () => {
    setAuth({});
    await send("io0013", {}, showLoading)
    sessionStorage.clear()
    localStorage.clear()
    navigate('/');
  }

  useEffect(() => {
    return () => {
      if (preview) URL.revokeObjectURL(preview);
    };
  }, [preview]);

  if (isComplete) {
    return (
      <div className="min-h-screen flex flex-col">
        <header className="flex items-center justify-between px-6">
          <Logo />
          <div className="flex items-center gap-3">
            <LanguageToggle />
            <Button
              variant="ghost"
              size="sm"
              onClick={handleLogout}
              className="text-muted-foreground hover:text-foreground"
            >
              <LogOut className="h-4 w-4 md:mr-2" />
              <span className="hidden md:inline">{t('logout')}</span>
            </Button>
          </div>
        </header>

        <main className="flex-1 flex items-center justify-center p-6">
          <div className="w-full max-w-lg space-y-8 animate-fade-up text-center">
            <div>
              <div className="w-20 h-20 bg-success/10 rounded-full flex items-center justify-center mx-auto mb-6">
                <Check className="h-10 w-10 text-success" />
              </div>
              <h2 className="text-2xl md:text-3xl font-bold text-foreground">
                {t('welcomeMerchant')}, {businessName}!
              </h2>
              <p className="mt-2 text-muted-foreground">
                {t('merchantAccountReady')}
              </p>
            </div>

            {/* <div className="card-elevated p-6 space-y-4">
              <Label className="text-sm font-medium">{t('yourPayLink')}</Label>
              <div className="flex gap-2">
                <div className="flex-1 bg-muted rounded-xl px-4 py-3 text-sm font-mono text-muted-foreground truncate">
                  {payLink}
                </div>
                <Button
                  onClick={handleCopyLink}
                  variant={copied ? 'success' : 'default'}
                  className="shrink-0"
                >
                  {copied ? (
                    <>
                      <Check className="h-4 w-4 mr-2" />
                      {t('copied')}
                    </>
                  ) : (
                    <>
                      <Copy className="h-4 w-4 mr-2" />
                      {t('copyLink')}
                    </>
                  )}
                </Button>
              </div>
            </div> */}

            <Button
              onClick={handleGoToDashboard}
              variant="gradient"
              size="lg"
              className="w-full"
            >
              {t('goToDashboard')}
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col">
      <header className="sticky top-0 flex items-center justify-between p-3 md:p-6 bg-white z-50">
        <Logo />
        <div className="flex items-center gap-3">
          <LanguageToggle />
          <Button
            variant="ghost"
            size="sm"
            onClick={handleLogout}
            className="hidden md:flex text-muted-foreground hover:text-foreground"
          >
            <LogOut className="h-4 w-4 mr-2" />
            {t('logout')}
          </Button>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-lg space-y-8 animate-fade-up">
          <div className="text-center">
            <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <Store className="h-8 w-8 text-primary" />
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground">
              {t('merchantSetup')}
            </h2>
            <p className="mt-2 text-muted-foreground">
              {t('merchantSetupSubtitle')}
            </p>
          </div>

          <div className="card-elevated p-8">
            <form onSubmit={handleSubmit} className="space-y-5">
              <div className="space-y-2">
                <Label htmlFor="businessName">{t('businessName')}</Label>
                <div className="relative">
                  <Store className="absolute left-4 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                  <Input
                    id="businessName"
                    placeholder={t('businessNamePlaceholder')}
                    value={businessName}
                    onChange={(e) => setBusinessName(e.target.value)}
                    className="pl-11"
                    maxLength={20}
                    required
                  />
                </div>
              </div>

              <div className="space-y-2">
                <Label htmlFor="logo">{t('businessLogo')}</Label>
                <div
                  onClick={() => fileInputRef.current?.click()}
                  className="border-2 border-dashed border-border rounded-xl p-8 text-center hover:border-primary/50 transition-colors cursor-pointer"
                >
                  {preview ? (
                    <img
                      src={preview}
                      alt="Logo preview"
                      className="mx-auto h-24 object-contain"
                    />
                  ) : (
                    <>
                      <Upload className="h-8 w-8 mx-auto text-muted-foreground mb-2" />
                      <p className="text-sm text-muted-foreground">
                        {file ? file.name : t('uploadLogo')}
                      </p>
                      <p className="text-xs text-muted-foreground mt-1">
                        {t('fileUploadHint')}
                      </p>
                    </>
                  )}

                </div>
                {/* hidden input */}
                <input
                  ref={fileInputRef}
                  type="file"
                  accept="image/*"
                  className="hidden"
                  onChange={handleFileChange}
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="mcc">{t("mcc")}</Label>
                <Select value={mcc} onValueChange={setMcc} required>
                  <SelectTrigger className="h-11">
                    <div className="flex items-center gap-3">
                      <Building2 className="h-4 w-4 text-muted-foreground" />
                      <SelectValue placeholder={t("selectMcc")} />
                    </div>
                  </SelectTrigger>
                  <SelectContent>
                    {mccs
                      .slice() // original array-г эвдэхгүй
                      .sort((a, b) => (t(a.name)).localeCompare(t(b.name)))
                      .map((mcc) => (
                        <SelectItem key={mcc.id} value={mcc.id}>
                          {t(mcc.name)}
                        </SelectItem>
                      ))}
                  </SelectContent>
                </Select>
              </div>

              <div className="space-y-2">
                <Label htmlFor="description">{t('businessDescription')}</Label>
                <div className="relative">
                  <FileText className="absolute left-4 top-3.5 h-4 w-4 text-muted-foreground" />
                  <Textarea
                    id="description"
                    placeholder={t('describeYourBusiness')}
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    className="pl-11 min-h-[100px] resize-none"
                  />
                </div>
              </div>

              {/* {businessName && (
                <div className="space-y-2 animate-fade-up">
                  <Label className="flex items-center gap-2">
                    <Link2 className="h-4 w-4 text-muted-foreground" />
                    {t('yourPayLink')}
                  </Label>
                  <div className="bg-muted rounded-xl px-4 py-3 text-sm font-mono text-muted-foreground">
                    {payLink}
                  </div>
                </div>
              )} */}

              {/* <div className="space-y-2 pt-2">
                <Label className="text-muted-foreground">{t('payoutAccount')}</Label>
                <div className="bg-muted/50 rounded-xl px-4 py-3 text-sm text-muted-foreground">
                  {user?.bankName} • {user?.bankAccount}
                </div>
              </div> */}

              <Button
                type="submit"
                variant="gradient"
                size="lg"
                className="w-full mt-6"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                    {t('loading')}
                  </>
                ) : (
                  <>
                    {t('continue')}
                    <ArrowRight className="ml-2 h-4 w-4" />
                  </>
                )}
              </Button>
            </form>
          </div>
        </div>
      </main>
    </div>

  );
};

export default MerchantSetup;
